import {
  STYLEFILTERBUTTON,
  COLORFILTERBUTTON,
  CLASS_NAME_OUTLINE_FOCUS
} from "./constants";
import Metadata from "../../requests/apa/Metadata";
import DeviceStorage from "../DeviceStorage/DeviceStorage";

export const validateMusicNode = () => {
  const location = window.location.toString();
  const validation = location.indexOf("claromusica") !== -1;
  return validation;
}

export const setRedColorButton = (evt: any) => {
  if(evt && evt.id && evt.id.includes(STYLEFILTERBUTTON)){
    evt.style.backgroundColor = COLORFILTERBUTTON;
  }
};

export const removeDynamicFocus = () => {
  const maskFocus = document.querySelector(".focus-container")
  if(maskFocus) maskFocus.style.display = "none";
}

export const isActiveFocusDynamic = () => {
  const region = DeviceStorage.getItem('region');
  const isEnable = Metadata.get('enable_foco', '{}');

  const getValueKey = JSON.parse(isEnable)
  return getValueKey[region] ? getValueKey[region].enable : (getValueKey["default"] ? getValueKey["default"].enable : false);
}

export const applyOutLineFocus = () => {
  return isActiveFocusDynamic() ? CLASS_NAME_OUTLINE_FOCUS : "";
}



// WEBPACK FOOTER //
// ./src/components/Focus/utils.ts